import { Model } from '@vuex-orm/core';

export default class Objekt extends Model {
  static entity = 'benutzer';
  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {number | null} */
    this.id;
    /** @type {string | null} */
    this.msid;
    /** @type {string | null} */
    this.email;
    /** @type {string | null} */
    this.passwort;
    /** @type {string | null} */
    this.anrede;
    /** @type {string | null} */
    this.vorname;
    /** @type {string | null} */
    this.nachname;
    /** @type {string | null} */
    this.firma;
    /** @type {string | null} */
    this.plz;
    /** @type {string | null} */
    this.ort;
    /** @type {string | null} */
    this.mobil;
    /** @type {string | null} */
    this.telefon;
    /** @type {string | null} */
    this.fax;
    /** @type {number | null} */
    this.status;
    /** @type {string | null} */
    this.idhash;
    /** @type {any} */
    this.erstelltam;
    /** @type {number | null} */
    this.newsletter;
    /** @type {any} */
    this.acktimestamp;
    /** @type {number | null} */
    this.profil;
    /** @type {string | null} */
    this.adresse1;
    /** @type {string | null} */
    this.adresse2;
    /** @type {any} */
    this.modtimestamp;
    /** @type {any} */
    this.lastlogin;
    /** @type {any} */
    this.favoriten;
    /** @type {string | null} */
    this.suchparameter;
    /** @type {string | null} */
    this.hilfe;
    /** @type {number | null} */
    this.objektinhaber;
    /** @type {string | null} */
    this.interessen;
    /** @type {number | null} */
    this.userlevel;
    /** @type {number | null} */
    this.maillevel;
    /** @type {number | null} */
    this.nologging;
    /** @type {number | null} */
    this.agbversion;
    /** @type {any} */
    this.agbackdate;
  }

  static fields() {
    return {
      id: this.number(0).nullable(),
      msid: this.string('').nullable(),
      email: this.string('').nullable(),
      passwort: this.string('').nullable(),
      anrede: this.string('').nullable(),
      vorname: this.string('').nullable(),
      nachname: this.string('').nullable(),
      firma: this.string('').nullable(),
      plz: this.string('').nullable(),
      ort: this.string('').nullable(),
      mobil: this.string('').nullable(),
      telefon: this.string('').nullable(),
      fax: this.string('').nullable(),
      status: this.number(0).nullable(),
      idhash: this.string('').nullable(),
      erstelltam: this.attr(undefined).nullable(),
      newsletter: this.number(0).nullable(),
      acktimestamp: this.attr(undefined).nullable(),
      profil: this.number(0).nullable(),
      adresse1: this.string('').nullable(),
      adresse2: this.string('').nullable(),
      modtimestamp: this.attr(undefined).nullable(),
      lastlogin: this.attr(undefined).nullable(),
      favoriten: this.attr([]).nullable(),
      suchparameter: this.string('').nullable(),
      hilfe: this.string('').nullable(),
      objektinhaber: this.number(0).nullable(),
      interessen: this.string('').nullable(),
      userlevel: this.number(0).nullable(),
      maillevel: this.number(0).nullable(),
      nologging: this.number(0).nullable(),
      agbversion: this.number(0).nullable(),
      agbackdate: this.attr(undefined).nullable()
    };
  }
}
